<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{
  scheme: any
}>()

const openItems = ref<Set<string>>(new Set())

const toggle = (code: string) => {
  if (openItems.value.has(code)) openItems.value.delete(code)
  else openItems.value.add(code)
}

const isOpen = (code: string) => openItems.value.has(code)

const endorsements = props.scheme?.Covers?.[0]?.Endorsements ?? []
</script>

<template>
  <div class="card-shadow card rounded-lg mb-4 overflow-hidden">
    <div class="card-body p-0">
      <div class="border-bottom px-3 py-3">
        <div class="d-flex align-items-center">
          <em class="far fa-shield-alt mr-2 text-info fs-24"></em>
          <span class="small text-uppercase text-muted font-weight-bold">Policy endorsements & exclusions</span>
        </div>
      </div>

      <div v-if="!endorsements.length" class="p-20 text-muted">
        No endorsements apply to this policy.
      </div>

      <div v-else>
        <div
          v-for="endorsement in endorsements"
          :key="endorsement.Code"
          class="border-bottom"
        >
          <div
              class="bgc-teal-50 border-info border-left d-flex justify-content-between align-items-center px-3 py-3"
              style="border-left-width: 4px !important;"
            >
            <div class="font-weight-bold text-dark">
              {{ endorsement.Summary }}
            </div>

            <a
              href="#"
              class="small text-uppercase font-weight-bold text-muted fs-12"
              @click.prevent="toggle(endorsement.Code)"
            >
              <span v-if="isOpen(endorsement.Code)"><em class="far fa-eye-slash mr-1" />Hide</span>
              <span v-else><em class='far fa-eye'></em> Show</span>
            </a>
          </div>

          <div v-if="isOpen(endorsement.Code)" class="px-3 pb-3">
            <div class="p-20 rounded">
              <div class="mb-2">
                <strong class="text-info">Summary:</strong>
                <span class="ml-1">{{ endorsement.Summary }}</span>
              </div>

              <div>
                <strong class="text-info">Content:</strong>
                <span class="ml-1" v-html="endorsement.Content"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>